import sources from '~/diptyqueTheme/config/assetSources';
import { domainOnlyRegex } from '~/diptyqueTheme/helpers/regexes';

export const getAssetSource = (link: string): string => {
  const match = link.match(domainOnlyRegex);
  const domain = match ? match[1] : null;

  return sources[domain] ||  'unknown';
};
